import { useMemo } from 'react';
import Flex from '@creditflowresearch/uilib/Flex';
import CollapsibleSectionList from '@creditflowresearch/uilib/CollapsibleSectionList';
import { ISection } from '@creditflowresearch/uilib/Section';
import SectionService from '@/creditflowresearch/domain/Header/Section';

import styles from './sectionLayout.module.scss';

interface ISectionLayoutMobileProps {
  title?: string,
  sectionsGrid: ISection[][][],
}

const SectionLayoutMobile = ({
  title,
  sectionsGrid,
}: ISectionLayoutMobileProps) => {
  const sections = useMemo(() => SectionService.flattenSectionsGrid(sectionsGrid), [sectionsGrid]);

  if (!sections.length) {
    return null;
  }

  return (
    <Flex direction="column" gap={ 0 }>
      { title && (
        <Flex
          as="h2"
          className={ styles.title }
          style={ { paddingLeft: '20px' } }
        >
          { title }
        </Flex>
      ) }
      <CollapsibleSectionList sections={ sections } />
    </Flex>
  );
};

export default SectionLayoutMobile;
